import React, { useRef, useEffect } from 'react';

const CheckoutForm = () => {
  // Create a ref for the form element.
  const formRef = useRef(null);
  const paymentAPIkey = process.env.REACT_APP_OmiseAPI;
  const backendUrl = (process.env.REACT_APP_BeUrl || '').replace(/\/+$/, '');

  // Configure OmiseCard on component mount.
  useEffect(() => {
    if (window.OmiseCard && paymentAPIkey) {
      window.OmiseCard.configure({
        publicKey: paymentAPIkey,
      });
    }
  }, [paymentAPIkey]);

  // Handle the checkout button click event.
  const handleCheckout = (event) => {
    event.preventDefault(); // Prevent the default form submission.

    const form = formRef.current;
    if (!window.OmiseCard) {
      console.error('OmiseCard is not loaded');
      return;
    }
    if (!backendUrl) {
      console.error('Backend URL is not configured');
      return;
    }

    // Open the Omise payment modal.
    window.OmiseCard.open({
      amount: 2000, // The amount in the smallest currency unit.
      currency: "THB",
      defaultPaymentMethod: "credit_card",
      onCreateTokenSuccess: (nonce) => {
        // Depending on the returned nonce, set the appropriate hidden field.
        if (nonce.startsWith("tokn_")) {
          form.elements["omiseToken"].value = nonce;
        } else {
          form.elements["omiseSource"].value = nonce;
        }
        // Submit the form.
        form.submit();
      }
    });
  };



  return (
    <form
      id="checkoutForm"
      method="POST"
      action={`${backendUrl}/charge`}
      ref={formRef}
    >
      <input type="hidden" name="omiseToken" />
      <input type="hidden" name="omiseSource" />
      <button
        type="submit"
        id="checkoutButton"
        onClick={handleCheckout}
      >
        Checkout
      </button>
    </form>
  );
};

export default CheckoutForm;
